import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { get } from "~/Services";

interface AppList {
  appName: string;
  apiUrl: string;
}

export interface DocumentDetailsResponse {
  approvalId: string;
  action: string;
  method: string;
  module: string;
  subModule: string;
  type: string | null;
  appList: AppList[];
  payload: any;
  status: string;
  reviewNotes?: string;
  createdAt: number;
  createdBy: string;
  creatorName: string;
  rejectionReason: string | null;
  published: boolean;
  drillDownTab: any;
  draftCount?: number;
  moduleKey?: string;
  airportName?: string;
}

const fetchDocumentDetails = async (approvalId: string): Promise<any> => {
  let response: any;
  if (approvalId) {
    response = await get(`/management/get-document-detail?approvalId=${approvalId}`);
  }
  console.log(response.response.data,'testres')
  return response.response.data;
};
const useDocumentDetails = (
  approvalId: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["documentDetails", approvalId],
      enabled: false,
      queryFn: () => {
        return fetchDocumentDetails(approvalId);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useDocumentDetails };
